"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _fetchWithAuth = _interopRequireDefault(require("./fetchWithAuth"));

var getItemData = function getItemData(itemUrl, accessToken, item) {
  if (!(0, _isEmpty2["default"])(item)) {
    return Promise.resolve(item);
  }

  return (0, _fetchWithAuth["default"])({
    accessToken: accessToken,
    endpointUrl: itemUrl
  });
};

var getDeliveryData = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(itemUrl, accessToken, item) {
    var itemData, itemSelfLink, analysisLink, deliveryConfigurations;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getItemData(itemUrl, accessToken, item);

          case 2:
            itemData = _context.sent;
            itemSelfLink = (0, _get2["default"])(itemData, '_links.self.href');
            analysisLink = (0, _get2["default"])(itemData, '_links.shipmentPlanningAnalysis.href');
            deliveryConfigurations = (0, _get2["default"])(itemData, 'deliveryConfigurations');
            return _context.abrupt("return", {
              itemData: itemData,
              itemSelfLink: itemSelfLink,
              analysisLink: analysisLink,
              deliveryConfigurations: deliveryConfigurations
            });

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getDeliveryData(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var _default = getDeliveryData;
exports["default"] = _default;